export const CURRENCIES = [
	{ value: 'CHF', label: 'CHF' },
	{ value: 'EUR', label: 'EUR' },
	{ value: 'USD', label: 'USD' },
	{ value: 'CAD', label: 'CAD' },
];
